import { render, staticRenderFns } from "./UserGroupUsers.vue?vue&type=template&id=76128ffa&scoped=true&"
import script from "./UserGroupUsers.vue?vue&type=script&lang=ts&"
export * from "./UserGroupUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76128ffa",
  null
  
)

export default component.exports